"use client"

import { useEffect, useState } from "react"
import { unreadStore } from "@/utils/realtime/unreadStore"

export function useUnreadCount(userId?: string | null) {
  const [unreadByRoom, setUnreadByRoom] = useState<Record<string, boolean>>({})

  useEffect(() => {
    unreadStore.start(userId)
    const unsub = unreadStore.subscribe(setUnreadByRoom)
    return () => { unsub() }
  }, [userId])

  // Mirror chat's instant path using a resilient manager: subscribe to per-room broadcast channels and
  // optimistically mark the room unread when a message arrives from others, with auto-reconnect.
  // No direct realtime subscription here; unreadStore handles broadcasts and merges.

  // Calculate total unread count
  const totalUnreadCount = Object.values(unreadByRoom).filter(Boolean).length
  // Dev-only logging can be re-enabled if needed

  // Mark conversation as read
  const markConversationRead = async (roomName: string) => {
    if (!userId) return
    return unreadStore.markRead(roomName)
  }

  return {
    unreadCount: totalUnreadCount,
    totalUnreadCount,
    unreadByRoom,
    markConversationRead
  }
}
